<template lang="">
  <v-tooltip top content-class="comment__box" v-model="show">
    <template v-slot:activator="{ on, attrs }">
      <v-icon class="ml-2" size="16" dark v-bind="attrs" v-on="on">
        {{ show ? "$vuetify.icons.chatActive" : "$vuetify.icons.chatDisabled" }}
      </v-icon>
    </template>
    <span><span class="text-info mr-1">Comment:</span> {{ content }}</span>
  </v-tooltip>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
    },
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>
<style scoped lang="scss">
.comment__box {
  color: var(--v-primary-base);
  border: 1px solid var(--v-info-base) !important;
  background-color: var(--v-white-base);

  &:before {
    content: "";
    position: absolute;
    right: 46.5%;
    bottom: -42%;
    width: 22px;
    height: 13px;
    background-color: var(--v-info-base);
    clip-path: polygon(50% 100%, 1% 0, 100% 0);
  }
  &:after {
    content: "";
    position: absolute;
    right: 47.125%;
    bottom: -40%;
    width: 18px;
    height: 13px;
    background-color: #fff;
    clip-path: polygon(50% 100%, 1% 0, 100% 0);
    border-top: 5px solid var(--v-white-base);
    z-index: 10000000000000000000000;
  }
}
</style>
